import { render, staticRenderFns } from "./GuidesView.vue?vue&type=template&id=1525bad9&scoped=true&"
import script from "./GuidesView.vue?vue&type=script&lang=js&"
export * from "./GuidesView.vue?vue&type=script&lang=js&"
import style0 from "./GuidesView.vue?vue&type=style&index=0&id=1525bad9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1525bad9",
  null
  
)

export default component.exports